import React from 'react';
import ConditionalLink from '@plone/volto/components/manage/ConditionalLink/ConditionalLink';

interface CardIconProps {
  title?: string;
  icon?: string;
}

interface WrappedCardIconProps extends CardIconProps {
  openLinkInNewPage?: boolean;
  isEditMode?: boolean;
}

interface BrandIcon {
  name: string;
}

const BRAND_ICONS: readonly BrandIcon[] = [
  { name: 'facebook' },
  { name: 'facebook-f' },
  { name: 'facebook-messenger' },
  { name: 'square-facebook' },
  { name: 'google' },
  { name: 'google-drive' },
  { name: 'google-play' },
  { name: 'google-plus' },
  { name: 'google-plus-g' },
  { name: 'square-google-plus' },
  { name: 'google-wallet' },
  { name: 'google-scholar' },
  { name: 'google-pay' },
  { name: 'instagram' },
  { name: 'square-instagram' },
  { name: 'linkedin' },
  { name: 'linkedin-in' },
  { name: 'tiktok' },
  { name: 'twitch' },
  { name: 'twitter' },
  { name: 'square-twitter' },
  { name: 'x-twitter' },
  { name: 'square-x-twitter' },
  { name: 'youtube' },
  { name: 'square-youtube' },
] as const;

const isBrandIcon = (iconName?: string): boolean => {
  if (!iconName) return false;
  return BRAND_ICONS.some((icon) => icon.name === iconName);
};

const getIconClass = (iconName?: string): string => {
  return isBrandIcon(iconName) ? 'fab' : 'fas';
};

export const CardIcon: React.FC<CardIconProps> = ({ icon, title }) => {
  const iconClass = getIconClass(icon);

  return (
    <div className="card-content cardIcon">
      {icon && (
        <span className="card-icon">
          <i className={`${iconClass} fa-${icon} icon-card`} />
        </span>
      )}
      <div className="title-card">
        <h5>{title}</h5>
      </div>
    </div>
  );
};

export const WrappedCardIcon: React.FC<WrappedCardIconProps> = ({
  link,
  openLinkInNewPage,
  icon,
  title,
  isEditMode,
}) => {
  return (
    <ConditionalLink
      condition={!isEditMode && !!link}
      href={link}
      openLinkInNewTab={openLinkInNewPage}
    >
      <CardIcon title={title} icon={icon} />
    </ConditionalLink>
  );
};
